import { STEP_PATHS } from './consts';

export const NON_MEDICAL_FLOW = [
  {
    label: 'Travel information',
    path: STEP_PATHS.TRAVEL_INFORMATION
  },
  {
    path: STEP_PATHS.DESCRIPTION,
    label: 'Description',
    isSubStep: true
  },
  {
    path: STEP_PATHS.OTHER_PARTIES,
    label: 'Other parties'
  },
  {
    path: STEP_PATHS.PERSONAL_INFORMATION,
    label: 'Personal information'
  },
  {
    path: STEP_PATHS.REIMBURSEMENT,
    label: 'Reimbursement'
  },
  {
    path: STEP_PATHS.UPLOAD_DOCUMENTS,
    label: 'Upload documents'
  },
  {
    path: STEP_PATHS.ID_VERIFICATION,
    label: 'ID Verification',
    isSubStep: true
  },
  {
    path: STEP_PATHS.SUMMARY,
    label: 'Review & submit'
  }
];

export const MEDICAL_FLOW = [
  {
    label: 'Medical information',
    path: STEP_PATHS.TRAVEL_INFORMATION
  },
  {
    path: STEP_PATHS.PRE_EX,
    label: 'Pre-existing condition',
    isSubStep: true
  },
  {
    path: STEP_PATHS.DESCRIPTION,
    label: 'Description',
    isSubStep: true
  },
  {
    path: STEP_PATHS.OTHER_PARTIES,
    label: 'Other parties'
  },
  {
    path: STEP_PATHS.PERSONAL_INFORMATION,
    label: 'Personal information'
  },
  {
    path: STEP_PATHS.REIMBURSEMENT,
    label: 'Reimbursement'
  },
  {
    path: STEP_PATHS.UPLOAD_DOCUMENTS,
    label: 'Upload documents'
  },
  {
    path: STEP_PATHS.ID_VERIFICATION,
    label: 'ID Verification',
    isSubStep: true
  },
  {
    path: STEP_PATHS.SUMMARY,
    label: 'Review & submit'
  }
];
